<template>
  <div class="grade">
    <div class="grade_box1">
      <div class="grade_box1_1">
        <img class="grade_box1_1_img" src="../../assets/appraisalOne.png" alt />
        <img class="grade_box1_img" src="../../assets/appraisalTwo.png" alt />
        <img class="grade_box1_img_2" src="../../assets/appraisalTwo.png" alt />
        <img class="grade_box1_img_3" src="../../assets/appraisalTwo.png" alt />
      </div>
    </div>
    <div class="grade_box2">
      <div class="grade_box2_1">
        <div>
          <img src="../../assets/rectangle.png" alt />
          <span class="rectangleSpan">信息报告</span>
        </div>
        <div class="information" v-if="gradeList.studentName">
          <el-row :gutter="20" class="elRowInfo">
            <el-col :span="12">
              <div class="informationFlex">
                <div class="left">学生姓名:</div>
                <div>{{ gradeList.studentName }}</div>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="informationFlex">
                <div class="left">实测日期:</div>
                <div>{{ gradeList.answerDate }}</div>
              </div>
            </el-col>
          </el-row>
          <el-row :gutter="20" class="elRowInfo">
            <el-col :span="12">
              <div class="informationFlex" v-if="gradeList.student.classInfo">
                <div class="left">学 校:</div>
                <div>
                  {{ schooolName(gradeList.student.classInfo.schoolId) }}
                </div>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="informationFlex">
                <div class="left">出生日期:</div>
                <div>{{ gradeList.student.birthday }}</div>
              </div>
            </el-col>
          </el-row>
          <el-row :gutter="20" class="elRowInfo">
            <el-col :span="12">
              <div class="informationFlex" v-if="gradeList.student.classInfo">
                <div class="left">年 级:</div>
                <div>{{ gradeList.student.classInfo.classInfo }}</div>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="informationFlex">
                <div class="left">年 龄:</div>
                <div>{{ gradeList.studentAge }}</div>
              </div>
            </el-col>
          </el-row>
          <el-row :gutter="20" class="elRowInfo">
            <el-col :span="12">
              <div class="informationFlex">
                <div class="left">性 别:</div>
                <div>{{ manGirls(gradeList.student.sex) }}</div>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="informationFlex">
                <div class="left">施测起止时间:</div>
                <div>{{ dateTimeAllShow }}</div>
              </div>
            </el-col>
          </el-row>
          <el-row :gutter="20" class="elRowInfo">
            <el-col :span="12">
              <div class="informationFlex">
                <div class="left">施测人员:</div>
                <div>{{ gradeList.updatorName }}</div>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="informationFlex">
                <div class="left">施测时间共:</div>
                <div>{{ totalTime }}分钟</div>
              </div>
            </el-col>
          </el-row>
          <el-row :gutter="20" class="elRowInfo">
            <el-col :span="12">
              <div class="informationFlex">
                <div class="left">实验总得分:</div>
                <div>{{ obstaAll }} 分</div>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="informationFlex">
                <div class="left">百分等级:</div>
                <div>待开发</div>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
      <div class="grade_box2_2">
        <div>
          <img src="../../assets/rectangle.png" alt />
          <span class="rectangleSpan">这份报告你会看到</span>
        </div>
        <div class="studentAll">
          <div class="student">
            <div class="text">学生</div>
            <div class="text">基本信息</div>
          </div>
          <div class="student student2">
            <div class="text">相关</div>
            <div class="text">测评数据</div>
          </div>
          <div class="student student3">
            <div class="text">详细</div>
            <div class="text">测评量表</div>
          </div>
        </div>
        <div>
          <el-button @click="examine" round class="examine">
            <div class="examine_box2">
              <div>
                <div class="examine_click">点我查看</div>
                <div>测评量表详情</div>
              </div>
              <div class="icon_1">
                <i class="el-icon-right"></i>
              </div>
            </div>
          </el-button>
        </div>
        <!-- <img src="../../assets/circle.png" alt /> -->
      </div>
    </div>
    <div class="grade_box3">
      <div>
        <img src="../../assets/rectangle.png" alt />
        <span class="rectangleSpan">测评说明</span>
      </div>
      <div class="grade_box3_one">
        <p>一、本测试共分为六个分测试：</p>
        <div class="grade_box3_two">
          <div class="roundA"></div>
          <p>图形辨别：共23题，评量受试者对图形异同的辨熟能力；</p>
        </div>
        <div class="grade_box3_two">
          <div class="roundA"></div>
          <p>补充图形：共7题，评量受试者对于图形的完整性、恒常性的补充能力；</p>
        </div>
        <div class="grade_box3_two">
          <div class="roundA"></div>
          <p>隐蔽图形：共12题，评量受试者对于图形认知的能力；</p>
        </div>
        <div class="grade_box3_two">
          <div class="roundA"></div>
          <p>图形关系：共25题，评量受试者对于图形彼此间关系的认知能力；</p>
        </div>
        <div class="grade_box3_two">
          <div class="roundA"></div>
          <p>图形系列：共20题，评量受试者对于图形变化顺序的推理能力；</p>
        </div>
        <div class="grade_box3_two">
          <div class="roundA"></div>
          <p>
            图形关系系列：共5题，评量受试者对于图形的变化及彼此间存在的关系之辨别能力；
          </p>
        </div>
        <p>
          二、受试从第一题作到第九十二题，每答对一题给一分，全部答对为92分。
        </p>
      </div>
    </div>
    <div class="grade_box4">
      <div>
        <img src="../../assets/rectangle.png" alt />
        <span class="rectangleSpan">答题情况汇总表</span>
      </div>
      <div class="elTable">
        <table>
          <thead>
            <tr class="theadTr">
              <th>测验项</th>
              <th>原始分数</th>
              <th>测验项</th>
              <th>原始分数</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>分测验二</td>
              <td>{{ obstaOne }}</td>
              <td>分测验四</td>
              <td>{{ obstaTwo }}</td>
            </tr>

            <!-- <tr>
              <td>隐蔽图形测验</td>
              <td>{{gradeList.hiddenFiguresScore}}</td>
              <td>图形关系系列测验</td>
              <td>{{gradeList.figuresRelationSeriesScore}}</td>
            </tr>-->
            <tr>
              <td class="theadTr">原始得分总数</td>
              <td colspan="4" class="add">{{ obstaAll }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div>老师评语</div>
    </div>
    <!-- <img class="grade_box1_img_2" src="../../assets/appraisalTwo.png" alt /> -->
  </div>
</template>

<script>
import { getScore, scaleAnswerList, schoolList } from '@/api/login/login.js';
export default {
  name: 'grade',
  components: {},
  props: {},
  data() {
    return {
      studentId: sessionStorage.getItem('studentIdA'),
      totalTime: sessionStorage.getItem('totalTime'),
      gradeList: {
        studentName: '',
        student: {},
        score: 0
      },
      fizeA: 'B',
      questionList: [],
      obstaOne: '0',
      obstaTwo: '0',
      obstaAll: '0',
      dateTimeAllShow:
        sessionStorage.getItem('dateTimeAllShow') +
        ' - ' +
        sessionStorage.getItem('dateTimeAllShowB'),
      columns: ['测验项', '原始分数', '测验项', '原始分数'],
      pagination: {
        offset: 0,
        total: 0,
        currentPage: 1,
        limit: 100
      },
      teacherArrayAA: []
    };
  },
  created() {
    this.getScore();
    this.questionInfosList();
    this.scaleAnswerList();
    this.schoolList();
  },
  mounted() {
    this.TopscrollTop();
  },
  watch: {},
  computed: {},
  methods: {
    TopscrollTop() {
      // document.querySelector(".grade").scrollTo(0, 0);
      window.scrollTo(0, 0);
    },
    // 答案
    async getScore() {
      const data = await getScore(this.studentId);
      console.log(data);
      if (data.code == 0) {
        if (data.data[0]) {
          this.gradeList = data.data[0];
        }
      }
    },
    manGirls(value) {
      if (value == 'M') {
        return '男';
      } else {
        return '女';
      }
    },
    questionInfosList() {
      this.questionList = JSON.parse(sessionStorage.getItem('questionList'));
      this.obstaOne = this.questionList[1].grade
        ? this.questionList[1].grade
        : 0;
      this.obstaTwo = this.questionList[3].grade
        ? this.questionList[3].grade
        : 0;
      this.obstaAll = this.obstaOne + this.obstaTwo;
    },

    // 答案展示
    async scaleAnswerList() {
      let params = {
        studentId: this.studentId
      };
      await scaleAnswerList(params);
    },
    labelToString(label) {
      return String(label);
    },
    examine() {
      this.$router.push({ name: 'obperfor' });
    },
    async schoolList() {
      try {
        let parmas = {
          pageNum: this.pagination.currentPage,
          pageSize: this.pagination.limit
        };
        const { data } = await schoolList(parmas);
        // console.log(data);
        this.teacherArrayAA = data;
      } catch (err) {
        console.log(err);
      }
    },
    schooolName(schoolId) {
      let result = this.teacherArrayAA.find((item) => item.id === schoolId);
      return result ? result.name : '';
    }
  }
};
</script>
<style lang="scss" scoped>
.grade {
  background-image: url('~@/assets/appraisal.png'); // 设置背景图片
  background-attachment: fixed;
  background-position: center;
  // background-size: 100% 100%;
  // height: 100%;
  background-size: cover;
  background-repeat: no-repeat;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-bottom: 30px;
}
.grade_box1 {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 1200px;
  height: 136px;
  margin-top: 33px;
  background-color: #fff;
  text-align: center;
  border-radius: 10px;
  position: relative;
  .grade_box1_1 {
    width: 100%;
    .grade_box1_1_img {
      width: 15%;
    }
  }
  img {
    width: 95%;
  }
}
.grade_box1_img {
  position: absolute;
  left: 23px;
  top: 113px;
}
.grade_box1_img_2 {
  position: absolute;
  left: 23px;
  top: 515px;
}

.grade_box2 {
  width: 1200px;
  height: 380px;
  background-color: #fff;
  border-radius: 10px;
  margin-top: 20px;
  display: flex;
  padding-top: 49px;
  padding-left: 21px;
  .grade_box2_1 {
    flex: 1.5;
  }
  .grade_box2_2 {
    flex: 1;
  }
}

.grade_box3 {
  width: 1200px;
  background-color: #fff;
  border-radius: 10px;
  margin-top: 20px;
  display: flex;
  flex-direction: column;
  // align-content: flex-start;
  // flex-wrap: wrap;
  padding-top: 49px;
  padding-left: 21px;
}
.rectangleSpan {
  margin-left: 15px;
  font-size: 24px;
}
.information {
  margin-left: 15px;
  margin-top: 20px;
  // height: 400px;
  // background-color: #0dc786;
  font-size: 18px;
  .elRowInfo {
    margin: 20px 0;
  }
  .informationFlex {
    display: flex;
    // justify-content: center;
    line-height: 1;
    .left {
      margin-right: 15px;
    }
  }
}
.student {
  width: 100px;
  height: 100px;
  border-radius: 50%;
  background-color: #ffcf2b;
  margin-right: 35px;
  margin-top: 25px;
  font-size: 20px;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
}
.student2 {
  background-color: #0dc786;
}
.student3 {
  background-color: #4589f6;
}
.text {
  // display: block;
  // width: 100%;
  // height: 100%;
  text-align: center; /* 可选 */
  color: #fff;
}
.studentAll {
  display: flex;
}
.grade_box3_one {
  height: 300px;
  margin-top: 20px;
  line-height: 30px;
}
.exerciseOne {
  margin-left: 10px;
  width: 33px;
  height: 33px;
  border: 1px solid #458af4;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.textA {
  text-align: center; /* 可选 */
  color: #458af4;
}
.textNum {
  font-size: 20px;
  margin-top: 2px;
}
.grade_box3_one_exer {
  display: flex;
  // justify-content: center;
  align-items: center;
  margin-bottom: 10px;
  width: 400px;
  height: 31px;
  .exer {
    font-size: 20px;
    margin-right: 20px;
  }
}
.checked {
  width: 33px;
  height: 33px;
  border-radius: 50%;
  background-color: #458af4;
}
.exerciseBig {
  display: flex;
}
.grade_box4 {
  width: 1200px;
  height: 350px;
  background-color: #fff;
  border-radius: 10px;
  margin-top: 20px;
  display: flex;
  flex-direction: column;
  padding-top: 49px;
  padding-left: 21px;
  ::v-deep .el-table {
    border: 1px solid #b5b5b5;
    border-radius: 10px;
  }
  .elTable {
    margin-top: 20px;
    padding-right: 30px;
    padding-left: 9px;
  }
  ::v-deep .el-table__empty-block {
    display: none;
  }
  ::v-deep.fizeColor {
    color: #458af4;
  }
}
.grade_box1_img_3 {
  position: absolute;
  left: 20px;
  top: 935px;
}
.examine {
  margin-top: 35px;
  background-color: #48cfe5;
  width: 220px;
  height: 70px;
  border-radius: 40px;
  border: 3px solid #b4ebf9;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
  font-size: 15px;
  .examine_box2 {
    display: flex;
    align-items: center;
  }
  .icon_1 {
    margin-left: 15px;
    font-size: 30px;
  }
  .examine_click {
    margin-bottom: 5px;
  }
}
.roundA {
  width: 10px;
  height: 10px;
  background-color: black;
  border-radius: 50%;
  margin: 0 24px;
}
.grade_box3_two {
  display: flex;
  align-items: center;
}
table {
  width: 100%;
  height: 100%;
  border: 1px solid #d8d8d8;

  border-radius: 4px;

  /* 消除单元格之间的空隙 */

  border-collapse: collapse;

  /* 消除掉外边框 */

  border-style: hidden;

  /* hack一下加个假边框 */

  box-shadow: 0 0 0 1px #d8d8d8;
}
tr {
  height: 40px;
}
th,
td {
  border: 1px solid #d8d8d8;
  text-align: center;
  width: 25%;
}
.theadTr {
  color: #458af4;
  font-weight: 800;
}
</style>